import React from 'react';
import { InfoMessage, Loading } from '@fasstech/middle-design-system';
import { isEmpty } from 'ramda';
import { isRequiredSelect } from '@@viewHelpers/validations/index.js';
import {
  ControlledRadioButton,
  ControlledSelect
} from '@@viewCommonComponents/controlled/index.js';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import {
  isNotNil,
  isNotNilOrEmpty
} from '../../../../server/helpers/index.mjs';
import CcnOfferInfos from './CcnOfferInfos.jsx';

const CcnsList = ({
  ccns,
  loadingCcns,
  getMiddleText,
  form,
  noCCN,
  otherCcns,
  loadingOtherCcns,
  options,
  optionsOtherCcns,
  ccnOffer,
  loadingCcnOffer,
  redirectionInfo,
  onSelectCcn,
  canGoNext
}) => {
  if (loadingCcns || loadingOtherCcns) {
    return <Loading />;
  }
  const ccnOfferInfosProps = {
    loadingCcnOffer,
    ccnOffer,
    getMiddleText,
    redirectionInfo,
    canGoNext
  };
  let ccn = form.watch('company.ccnRef');

  return (
    <div className={'w-full'}>
      {isEmpty(ccns) && (
        <InfoMessage iconName={'lightbulb'}>
          {getMiddleText('ENTREPRISE_CCN_SANS_CCN_MESSAGE_INFO')}
        </InfoMessage>
      )}
      {noCCN ? (
        <div className={'flex w-full py-4 gap-4'}>
          <div className={'w-1/2'}>
            <InfoMessage iconName={'lightbulb'}>
              {getMiddleText('ENTREPRISE_CCN_NON_CCN_MESSAGE_INFO')}
            </InfoMessage>
          </div>
          <CcnOfferInfos
            {...ccnOfferInfosProps}
            showInfoMessage={!loadingCcnOffer && isNotNil(ccnOffer)}
          />
        </div>
      ) : (
        <>
          {!isEmpty(ccns) && isNilOrEmpty(otherCcns) && (
            <div className={'flex gap-4'}>
              <div className={'w-1/2'}>
                <ControlledRadioButton
                  className={'flex flex-col gap-2'}
                  name="company.ccnRef"
                  options={options}
                  rules={isRequiredSelect(options, false)}
                  form={form}
                  withIndicator={false}
                  isMultiline
                  data-testid="ENTREPRISE_CCNS_RADIO"
                  extraChange={onSelectCcn}
                />
              </div>
              <CcnOfferInfos
                {...ccnOfferInfosProps}
                showInfoMessage={!loadingCcnOffer && isNotNilOrEmpty(ccn) && isNotNil(ccnOffer)}
              />

            </div>
          )}
          {!isNilOrEmpty(otherCcns) && (
            <div className={'flex w-full py-4 gap-4'}>
              <div className={'w-1/2'}>
                <ControlledSelect
                  label={getMiddleText(
                    'ENTREPRISE_CCN_CHOIX_AUTRE_CCN_BOUTON_LABEL'
                  )}
                  name="company.ccnRef"
                  options={optionsOtherCcns}
                  rules={isRequiredSelect(optionsOtherCcns, false)}
                  form={form}
                  withIndicator={false}
                  isMultiline
                  data-testid="ENTREPRISE_CCNS_SELECT"
                  extraChange={onSelectCcn}
                />
              </div>
              <CcnOfferInfos
                {...ccnOfferInfosProps}
                showInfoMessage={!loadingCcnOffer && isNotNilOrEmpty(ccn) && isNotNil(ccnOffer)}
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default CcnsList;
